import { FaChevronCircleRight } from "react-icons/fa";
import africanDrum from "../../assets/african-drum.jpg";
import family from "../../assets/family-illustration.webp";
import { t } from "../../translations";

import { useSelector } from "react-redux";
import "../styles/careers.css";

const JoinFamilyAbout = () => {
  const lang = useSelector((state) => state.lang);

  return (
    <div
      style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
    >
      <div
        className="familyContainer"
        style={{ display: "flex", justifyContent: "center", width: "100%" }}
      >
        <div className="familyTextContainer">
          <div
            style={{
              position: "relative",
              paddingBottom: "7px",
              marginBottom: "25px"
            }}
          >
            <h1 class="h1-family">{t("join_family.title", lang)}</h1>
          </div>
          <p className="familyParagraph">
            {t("join_family.description", lang)}
          </p>
        </div>
        <div className="familyImgContainer">
          <img src={family} alt="Panichef team illustration" />
        </div>
      </div>

      <div className="aboutusCareer">
        <div
          style={{
            position: "relative",
            paddingBottom: "7px",
            marginBottom: "25px",
            width: "fit-content"
          }}
        >
          <h1 class="h1-sectionTitle">{t("join_family.about_us", lang)}</h1>
        </div>
        <p style={{ fontSize: "1.1rem", marginBottom: "2rem" }}>
          {t("join_family.about_description_1", lang)}
        </p>
        <p style={{ fontSize: "1.1rem", marginBottom: "2rem" }}>
          {t("join_family.about_description_2", lang)}
        </p>

        <a href="/our-story" className="SavoirPlusLink">
          {t("join_family.learn_more", lang)}{" "}
          <FaChevronCircleRight className="FaChevronCircleAboutUS" />
        </a>
      </div>

      <div className="drumImgContainer">
        <img src={africanDrum} alt="african traditional drum" />
      </div>
    </div>
  );
};

export default JoinFamilyAbout;
